// extracted by mini-css-extract-plugin
module.exports = {"city":"city","image":"image","doctor-city__item":"doctor-city__item","doctorCityItem":"doctor-city__item"};